import { render, staticRenderFns } from "./TicketDetailReport.vue?vue&type=template&id=b7bf2152&scoped=true&"
import script from "./TicketDetailReport.vue?vue&type=script&lang=js&"
export * from "./TicketDetailReport.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailReport.vue?vue&type=style&index=0&id=b7bf2152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf2152",
  null
  
)

export default component.exports